// The G2 rating, from ONE source (g2Rating.json). Change it there only.
// Canon g2-claims: backlink + "Source: G2.com, Inc." required; no G2 logo until permission.
import data from './g2Rating.json';

export const G2_RATING = data.rating;
export const G2_URL = data.url;
